import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const FieldTranslationKeys = {
  configurationAutoSetDateHint: translationKey('field_configuration_auto_set_date_hint'),
  configurationDaysChip: translationKey('field_configuration_days_chip'),
  configurationDaysUnit: translationKey('field_configuration_days_unit'),
  configurationDeadlineHint: translationKey('field_configuration_deadline_hint'),
  configurationDefaultDaysLabel: translationKey('field_configuration_default_days_label'),
  configurationNoDeadlineHint: translationKey('field_configuration_no_deadline_hint'),
  documents: translationKey('field_documents'),
  modifiedBy: translationKey('field_modified_by'),
  valueProcessesDescription: translationKey('field_value_processes_description'),
  valuesAddOption: translationKey('field_values_add_option'),
  valuesEditOption: translationKey('field_values_edit_option'),
  valuesLabel: translationKey('field_values_label'),
  valuesLanguage: translationKey('field_values_language'),
  visibilitySelectProcessDropdownLabel: translationKey('field_visibility_select_process_dropdown_label'),
  visibilitySwitchDisabled: translationKey('field_visibility_switch_disabled'),
  visibilityWorkflowSectionTitle: translationKey('field_visibility_workflow_section_title'),
  visibilityWorkflowSelectLabel: translationKey('field_visibility_workflow_select_label'),
  addDocuments: translationKey('primaryField_Add_documents'),
  assignee: translationKey('primaryField_Assignee'),
  contractNumbers: translationKey('primaryField_Contract_numbers'),
  description: translationKey('primaryField_Description'),
  detectionDate: translationKey('primaryField_Detection_date'),
  executor: translationKey('primaryField_Executor'),
  level: translationKey('primaryField_Level'),
  positionOnMap: translationKey('primaryField_Position_on_map'),
  site: translationKey('primaryField_Site'),
  subcontractors: translationKey('primaryField_Subcontractors'),
  title: translationKey('primaryField_Title'),
} as const satisfies Record<string, TranslationKey>;
